/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { donationTypeEnumSchema } from "./donationTypeEnumSchema.ts";
import { z } from "zod";

export const userDonationListModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор платежа"),
"type": z.lazy(() => donationTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Donate</b>: Пожертвование</li>\n</ul>\n"),
"amount": z.number().int().describe("Сумма платежа в копейках"),
"date": z.string().datetime({ offset: true }).describe("Дата платежа")
    })